import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityState } from '@/shared/types/entity';
import { blockedMTOsApi } from '../api';
import type { BlockedMTOFilters, BlockedMTORequest } from '../types';

const initialState: EntityState<BlockedMTORequest, BlockedMTOFilters> = {
  items: [] as BlockedMTORequest[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    dateFrom: null,
    dateTo: null,
  },
};

const { actions, reducer } = createEntitySlice<BlockedMTORequest, BlockedMTOFilters, never>({
  name: 'blockedMTOsEntity',
  api: {
    getList: blockedMTOsApi.getList,
    getOne: () => Promise.reject(new Error('Prevented MTO requests are read-only')),
    create: () => Promise.reject(new Error('Prevented MTO requests are read-only')),
    update: () => Promise.reject(new Error('Prevented MTO requests are read-only')),
    delete: () => Promise.reject(new Error('Prevented MTO requests are read-only')),
  },
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.blockedMTOsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search) params.search = filters.search;

    if (filters.dateFrom) {
      params.dateFrom = filters.dateFrom;
    }

    if (filters.dateTo) {
      params.dateTo = filters.dateTo;
    }

    return params;
  },
});

export const {
  fetchItems: fetchBlockedMTOs,
  setPage: setBlockedMTOsPage,
  setPerPage: setBlockedMTOsPerPage,
  setFilters: setBlockedMTOsFilters,
} = actions;

export const blockedMTOsReducer = reducer;
